<template>
	<div class="productcenter">
			<div class="img">
				<img :src="banner"/>
			</div>
			<!--路径-->
			<div class="container">
				<div class="path">
					<el-breadcrumb separator-class="el-icon-arrow-right">
					  	<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
					  	<el-breadcrumb-item :to="{ path: '/ProductCenter' }">产品中心</el-breadcrumb-item>
					  	<el-breadcrumb-item>{{detailData.name}}</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
				
				<!--内容-->
				<div class="content clearfix">
					<div class="content-left">
						<p>产品列表</p>
						<el-col style="border: 1px solid #dfdfdf;">
							<el-menu
							default-active="2"
							class="el-menu-vertical-demo"
							@open="handleOpen"
							@close="handleClose">
								<div v-for="(item,index) in navList" :key="index">
									<el-submenu v-if="item.children" :index="item.id">
										<template slot="title">
											<span @click="getData(item.id)" style="width:100%;display:block">{{item.name}}</span>
										</template>
										<el-menu-item v-for="child in item.children" :index="item.id+'-'+child.id">
											<span @click="getData(child.id)" style="width:100%;display:block">{{child.name}}</span>
										</el-menu-item>
									</el-submenu>
									<el-menu-item v-if="!item.children" :index="item.id">
										<span @click="getData(item.id)" slot="title">{{item.name}}</span>
									</el-menu-item>
								</div>
							</el-menu>
						</el-col>
					</div>
					
					<div class="content-right">
						
						<div class="table">
							<div class="img">
								<div class="swiper-container gallery-top" id="gallery">
								    <div class="swiper-wrapper">
								      	<div class="swiper-slide" v-for="item in detailData.img" :style="item.bugImg">
								      	</div>
								    </div>
								    <div class="swiper-button-next swiper-button-white"></div>
								    <div class="swiper-button-prev swiper-button-white"></div>
								</div>
								<div class="swiper-container gallery-thumbs" id="thumbs">
								    <div class="swiper-wrapper">
								      	<div class="swiper-slide" v-for="item in detailData.img" :style="item.bugImg">
								      	</div>
								    </div>
								</div>
							</div>
							<div class="message">
								<h1>{{detailData.name}}</h1>
								<p>产品型号：{{detailData.product_sn}}</p>
							</div>
							
							<div class="product clearfix">
								<el-tabs v-model="activeName2" type="card" @tab-click="handleClick">
								    <el-tab-pane label="产品描述" name="first" v-html="detailData.detail">
								    </el-tab-pane>
								    <el-tab-pane label="配置管理" name="second">
										<el-table
										    :data="detailData.parameter"
										    border
										    style="width: 100%">
										    <el-table-column
										      	prop="name"
										      	label="名称"
										      	width="130"
										      	align="center">
										    </el-table-column>
										    <el-table-column
										      	prop="parameter"
										      	label="规格"
										      	width="">
										    </el-table-column>
									  	</el-table>
								    </el-tab-pane>
								</el-tabs>
							</div>
							
						</div>
									
					</div>
					
				</div>
				
				
				
			</div>
			
		
	</div>
</template>

<script>
	import Swiper from "swiper";
	import "swiper/dist/css/swiper.min.css";
	export default {
		name:'',
		components:{},
		data(){
			return{
				msg:'productcenter',
				activeNames: ['1','2','3','4','5'],
				navList:[],
				detailData:[],
				activeName2: 'first',
				name:'产品描述',
				banner:''
			}
		},
		methods: {
	        handleOpen(key, keyPath) {
		        console.log(key, keyPath);
		    },
		    handleClose(key, keyPath) {
		        console.log(key, keyPath);
		    },
		    handleClick(tab, event) {
        		console.log(tab, event);
      		},
			getData(id){
				this.$router.push({
							name:'ProductCenter',
							params: {
				          		id:id,
				          	}
				        })
			},
			getItemList(){
				this.axios({
					method: 'get',
					url: this.GLOBAL.productItemApi,
					data: {}
				})
				.then((res) => {
					this.navList = res.data.data;
					var arr = res.data.data[0];
				})
				.catch((err) => {
					console.log(err)
				})
			},
			getInfo(){
				var id = this.$route.query.id;
				this.axios({
					method: 'get',
					url: this.GLOBAL.productDetailApi+id,
					data: {}
				})
				.then((res) => {
					this.detailData = res.data.data;
					
				})
				.catch((err) => {
					console.log(err)
				})
			},
	      	selItem(item) {
				this.name = item.title;
				this.$router.push(item.rou);
			},
			getBanner(){
				this.axios({
					method: 'get',
					url: this.GLOBAL.getBannerApi+'5',
					data: {}
				})
				.then((res) => {
					this.banner = res.data.data.banner5;
				})
				.catch((err) => {
					console.log(err)
				})
			}
	      	
	   	},
	   	mounted(){
	   		setTimeout(function(){
	   			var galleryThumbs = new Swiper('#thumbs', {
					spaceBetween: 10,
					slidesPerView: 4,
					watchSlidesVisibility: true,//防止不可点击
			    });
			    var galleryTop = new Swiper('#gallery', {
			      	spaceBetween: 10,
			      	navigation: {
			        	nextEl: '.swiper-button-next',
			        	prevEl: '.swiper-button-prev',
			      	},
			      	thumbs: {
			        	swiper: galleryThumbs
			      	}
			    });
			},1000);
 		},
	   created(){
	   		this.getBanner();
	   		this.getItemList();
	   		this.getInfo();
	   }
		
	}
	


</script>

<style lang="less" scoped="scoped">
.productcenter{
	.img{
		width:100%;
		height:350px;
		img{
			width: 100%;
			height: 100%;
		}
	}
	.path{
		margin-top: 20px;
		margin-bottom: 20px;
		i{
			font-size: 20px;
		}
		span{
			color: #00A0FF;
		}
		.new{
			color: green;
		}
	}
	.content{
		margin-top: 50px;
		margin-bottom: 50px;		
		.content-left{
			display: inline-block;
			width: 25%;
			border-box:box-sizing;
			font-size:18px;
			p{
				width: 100%;
				height: 40px;
				text-align: left;
				line-height: 40px;
				padding-left: 40px;
				font-size: 18px;
				background: #229dfe;
				color: #fff;
			}
			.mosttitle{
				font-size: 20px;
				margin-left: 15px;
			}
			.clicklist{
				font-size: 16px;
				padding-left: 20px;
				margin-top: 5px;
				margin-left: 5px;
				cursor: pointer;
				.disc{
						display: inline-block;
						width: 5px ;
						height: 5px;
						background: #146BFF;
						border-radius: 50%;
						margin-right: 10px;
						margin-bottom: 3px;
					}
			}
			
		}
		.content-right{
			display: inline-block;
			width: 71%;
			margin-left: 35px;
			float: right;
			.table{
				width: 100%;
				border: 1px solid #ccc;
				.img{
					display: inline-block;
					height: 400px;
					width: 55%;
					border: 1px solid #eee;
					float: left;
					padding:20px;
					img{
						width: 100%;
						height: 65%;
						border-radius: 5px;
					}
					.NewHand{
						margin-top: 30px;
						.swiper-wrapper{
							.swiper-slide{
								margin-left: 15px;
								img{
									width: 75px;
									height: 80px;
									margin-right: 8px;
								}
								
							}
						}
						
						
					}
				}
				.message{
					display: inline-block;
					width: 40%;
					float: right;
					h1{
						font-size: 27px;
						margin-top: 30px;
						margin-bottom: 30px;
					}
					h3{
						font-size: 16px;
						margin-bottom: 30px;
					}
				}
				.product{
					margin-top: 20px;
					width: 100%;
					margin-top: 420px;
					padding:20px;
				}
			}
		}
	}
	.el-menu{
		border:0px;
	}
	.swiper-container {
      width: 100%;
      height: 300px;
      margin-left: auto;
      margin-right: auto;
    }
    .swiper-slide {
      background-size: cover;
      background-position: center;
    }
    .gallery-top {
      height: 80%;
      width: 100%;
    }
    .gallery-thumbs {
      height: 20%;
      box-sizing: border-box;
      padding: 10px 0;
    }
    .gallery-thumbs .swiper-slide {
      width: 25%;
      height: 100%;
      opacity: 0.4;
    }
    .gallery-thumbs .swiper-slide-thumb-active {
      opacity: 1;
    }
}

</style>


// WEBPACK FOOTER //
// src/components/pages/ProductCenter/ProDetail.vue